import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/admin/header/PageHeader";
import UserEditForm from "@/components/admin/userManagement/UserEditForm";
import { routes } from "@/configs/router.config/routes";
import { useUserList } from "@/hooks/useUserList";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { Role } from "@/models/user";
import { UserService } from "@/services/users/users.service";
import { showError, showSuccess } from "@/utils/notification";

const UserCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { mutate } = useUserList();
  const { currentWorkspaceId } = useWorkspaces();

  const submit = async (email: string, name: string, role: Role) => {
    try {
      setIsLoading(true);
      await UserService.createUser(email, name, role);
      await mutate();
      setIsLoading(false);
      showSuccess("ユーザーを作成しました。");
      navigate(routes.userList(currentWorkspaceId));
    } catch (error) {
      console.error(error);
      showError("ユーザーの作成に失敗しました。");
    }
  };

  return (
    <>
      <PageHeader hasBack title="新規ユーザー作成" />

      <UserEditForm submit={submit} isLoading={isLoading} />
    </>
  );
};

export default UserCreatePage;
